---
fr:
  budget_import:
    dialog_title: Importer des données budgétaires
    file_too_large: Le fichier est trop volumineux
    import_button: Importer des données budgétaires
    invalid_file: Le fichier n'a pas pu être lu. Il est peut-être corrompu ou dans un format incorrect.
    no_file_selected: Veuillez sélectionner un fichier à télécharger
    select_file: Sélectionner un fichier XLSX ou CSV
    upload: Télécharger
    upload_failed: Échec du téléchargement du fichier
  budget_tabs:
    charts: Graphiques
    tables: Tableaux
  budgets:
    edit_title: Budget pour
